import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useViewLabel } from '../useViewLabel';
import type { IViewTabsProps } from './IViewTabsProps';
import { facetFieldOf } from '../../menu/facetEntry';
import { customTabViewsOf, tabViewsOf } from './tabViews';

/**
 * Вкладки подань (UIUX views/view-switcher, прототип v4): сегментований перемикач — контейнер 2px на --surface2 з рамкою --line, вкладки 26px
 * 13px/500; вибрана — --surface з тінню й текстом --ink. Вужчий за вкладки рядок прокручує їх горизонтально без смуги прокрутки. Власне
 * подання записів («Бібліотека») — перша вкладка; поки воно відкрите, вкладок немає (прототип: showRecViews), повернення — через ліве меню.
 * Пункт меню «За …» (етапи за полем) — жодна вкладка не вибрана, як подання «facet» прототипу.
 */
export function ViewTabs({ rt, module, active, onChange }: IViewTabsProps) {
  const { t } = useTranslation();
  const label = useViewLabel(module);
  const [params] = useSearchParams();
  if (customTabViewsOf(rt).includes(active)) return null;
  const current = facetFieldOf(params.get('item')) && active === 'stages' ? '' : active;
  return (
    <div className="lv-tabs" role="group" aria-label={t('listbar.views')}>
      {tabViewsOf(rt).map((v) => (
        <button key={v} type="button" className={cx('lv-tabs__tab', v === current && 'is-on')} aria-pressed={v === current} onClick={() => onChange(v)}>
          {label(v)}
        </button>
      ))}
    </div>
  );
}
